export enum VoiceRoomRole {
  audience = 'audience',
  host = 'host',
  unknown = 'unknown',
}
